<template>
    <div class="card card-minimal-one mg-b-20" style="padding-bottom:0;min-height:375px;height:100%" v-loading='loading'>
        <div class="card-body" style="pointer-events:none">
            <label style='color: #1c273c;
                font-weight: 800;
                line-height: 1;
                text-transform:none;
                letter-spacing: .2px;'>
                Estimated Fund Investments <span style="font-weight: 400;
                color: #97a3b9;
                text-transform: none;">(as at {{yesterday}})</span>
            </label>
            <div class="row mg-t-20 mg-b-20">
                <div class="col-lg-12 mg-t-40 mg-lg-t-0" style="display: flex;flex-wrap:wrap;padding-right:0">
                    <div v-for="(key,value) in data.assets" :key="key" class="media wd50">
                        <div class="media-body" style='margin-bottom:10px'>
                            <label class="lb" style='font-size:10px;'>
                                <span class="square" :style='{background:colorDict[value]}'></span>
                                {{value}}
                            </label>
                            <h4 class='crt'>{{getFormattedCurrent(key)[0]}}<small>{{getFormattedCurrent(key)[1]}}</small></h4>
                            <span class='sp'>
                                <strong style="font-weight: 500;color: #031b4e;">{{getPercentage(key,data.total_value)}}</strong>
                                of Total
                            </span>
                        </div>
                    </div>
                    <!-- <div style="margin:3px;margin-top: 10px;">
                    <a href=""><small>Disclaimer</small></a>
                </div> -->
                </div>
            </div>

            <div class="chart-wrapper" style="pointer-events:auto;margin-top:40%">
                <chart-investments style='padding-left:5%;padding-right:5%;padding-top:20%;padding-bottom:5%' v-if="isChartShow" :combine_names_values='combine_names_values' :isfund='true' />
            </div>

        </div>
        <Disclaimer style="margin-left:85%" />
    </div>
</template>
<script>
import dateformats from '../../../utils/dateformats'
import currentformats from '../../../utils/currentformats'
export default {
    name:'fundinvestments',
    components: { 
        ChartInvestments: () => import('../../adviserpanel/charts/ChartInvestments.vue'),
        Disclaimer: () => import('../../adviserpanel/elements/Disclaimer.vue')
    },
    data(){
        return{
            yesterday:dateformats.getDay(),
            data:{
                assets:null,
                assets_sorted:null,
                total_value:'',
                asset_names:[],
                asset_values:[],
            },
            colorDict:null,
            combine_names_values:[],
            isChartShow:false,
            loading:true,
            isLong:''
        }
    },
    created(){
        this.getInvestmentsData();
    },
    methods:{
        getInvestmentsData: function(){
            this.$api.funddashboard_api.fundInvestments(this.$route.params.fund_code).then(response =>{
                //get the investments data from response
                this.data.assets = response.data["assets"]
                this.data.assets_sorted = response.data["assets_sorted"]
                this.data.total_value = response.data["total_value"]
                this.data.asset_names = response.data["asset_names"];
                this.data.asset_values = response.data["asset_values"];
                this.colorDict = this.getPieColor(response.data["asset_names_sorted"])
                this.combine_names_values = this.getChartData(this.data.assets_sorted)
                this.isChartShow=true
                this.loading=false
            });
        
        },
        getFormattedCurrent(k){
            let au = currentformats.AUformat(k);
            let [int,dec] = currentformats.splitCurrent(au);
            return [int,dec];
        },
        getPercentage(v,t){
            return ((v/t)*100).toFixed(2)+'%'
        },
        getPieColor(names){
            let colorList = [           
                '#8ECAE6','#4895EF','#4361EE','#3F37C9',                                    
                '#6247aa','#815ac0','#9381ff','#b8b8ff','#cbc0d3',
                '#efd3d7','#eee2df'                                              
            ];
            let colorDict ={}
            for (let i = 0; i < names.length; i++) {
                //or check with: if (b.length > i) { assignment }
                colorDict[names[i]] = colorList[i]
            }
            return colorDict
        },
        getChartData(obj){
            let array = []
            for(let key in obj){
                array.push(Object.assign({value:obj[key]}, {name: key}))
            }
            return array
        },
       
        
    }
}
</script>
<style>
.square{
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 2px;
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: .5px;
    word-wrap: break-word;
    -webkit-box-direction: normal;
}
.square::before, .square::after {
    box-sizing: border-box;
}
.lb{
    /* font-size: 10px; */
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: .5px;
    color: #031b4e;
    height:28px
}
.crt{
    font-size: 18px;
    font-family: Archivo, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-weight: 600;
    color: #1c273c;
    line-height: 1;
    letter-spacing: -1px;
    margin-bottom: 3px;
}
.sp{
    font-size: 11px;
    color: #97a3b9;
    font-weight: 400;
    line-height: 1.5;
}
.wd50{
    width:50%
}
.wd100{
    width:100%
}
</style>